/**
 * @hidden
 * @module ng1
 */ /** */
declare var angular;
import * as ng_from_import from 'angular';
let ng_from_global = angular;

/** @internal */
export const ng = (ng_from_import && ng_from_import.module) ? ng_from_import : ng_from_global;



// WEBPACK FOOTER //
// ./src/angular.ts